import { trackingUtils } from '@debijenkorf/dbk-common';

import { mapPdpProductToGA4Item } from './adapters/mapPdpProductToGA4Item';
import { viewItemEvent } from './ga4ProductModel';

import type { ProductDetailMapperProps } from '@/services/mappers/productDetailMapper';

export type VariantType = 'color' | 'size';

type ViewItem = {
  product: ProductDetailMapperProps;
  type?: VariantType;
};

export const viewItem = ({ product, type }: ViewItem) => {
  const item = mapPdpProductToGA4Item({ product, locationId: 'pdp' });

  trackingUtils.pushToDataLayer({
    colour_change: type === 'color',
    size_change: type === 'size',
    ...viewItemEvent(item),
  });
};
